<template>
  <div>
    <h3>{{ $t('views.vouchers.add.title') }}</h3>

    <formular ref="formular" :isBusy="is.loading" :controlDefinition="controlDefinition" maxWidth :labelCols="4" :showButtons="false" @formular:submit="onFormularSubmit" />

    <div class="formluar max-width">
      <b-form-row>
        <b-col cols="12">
          <b-form-group class="control-select" :label="tenantLabel" :label-cols="4" :state="tenantState">
            <b-input-group>
              <div class="control-wrapper">
                <b-select v-model="selectedTenant" :options="tenantOptions" :state="tenantState" />
              </div>
            </b-input-group>
            <b-form-invalid-feedback :state="tenantState">{{ $t('components.controls.feedbacks.invalid.required') }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-form-row>

      <div class="form-actions">
        <div class="justify-content-end">
          <b-button variant="secondary" @click="onAbort"><b-icon icon="abort" /> {{ $t('components.formular.action.abort') }}</b-button>
          <b-button variant="primary" @click="onSubmit"><b-icon icon="send" /> {{ $t('components.formular.action.submit') }}</b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/$plugins/http'
import Formular from '@/components/form/Formular'
import MixinEntityBase from '@/components/mixins/EntityBase'

const ENTITY_BY_KEY = 'vouchers'

export default {
  name: 'Vouchers.Add',
  mixins: [MixinEntityBase],
  components: {
    Formular
  },
  data () {
    return {
      selectedTenant: '',
      tenantDirty: false
    }
  },
  computed: {
    is () {
      return this.$store.getters[`${this.eParent.key}/is`]
    },
    definition () {
      return this.$store.getters[`${this.eParent.key}/definition`]
    },
    tenants () {
      return this.$store.getters['tenants/getUnwrapped'] || []
    },
    entityBy () {
      return this.ePath.find(e => e.key === ENTITY_BY_KEY)
    },
    tenantProperty () {
      return this.definition.properties.find(function (p) {
        return p.name.toLowerCase() === 'tenant'
      })
    },
    tenantLabel () {
      var prop = this.tenantProperty
      if (prop && prop.translations) {
        var trans = prop.translations[this.$i18n.locale]
        if (trans) {
          return trans.name
        }
      }
      return 'Tenant'
    },
    tenantOptions () {
      return [{ value: '', text: '' }].concat(
        this.tenants.map(function (t) {
          return { value: t.name, text: t.name }
        })
      )
    },
    tenantState () {
      if (!this.tenantDirty) {
        return null
      }
      return this.selectedTenant !== ''
    },
    controlDefinition () {
      return Object.assign({}, this.definition, {
        properties: this.definition.properties
          .filter(function (p) { return p.name.toLowerCase() !== 'tenant' })
          .map(function (p) {
            return Object.assign({}, p, { settings: Object.assign({}, p.settings || {}, { labelCols: '4' }) })
          })
      })
    }
  },
  methods: {
    onAbort () {
      this.$router.push({ name: 'Vouchers' })
    },
    onSubmit () {
      this.tenantDirty = true
      this.$refs.formular.onSubmit()
    },
    async onFormularSubmit (formData) {
      if (!this.selectedTenant) {
        return
      }
      var tenantKey = this.tenantProperty ? this.tenantProperty.name : 'Tenant'
      var entityData = Object.assign({ userId: this.entityBy.id }, formData.controls)
      entityData[tenantKey] = this.selectedTenant

      var code = entityData.Code || entityData.code
      if (code) {
        try {
          var response = await http({
            method: 'get',
            url: '/order/api/voucher/code-exists/' + encodeURIComponent(code) + '/' + encodeURIComponent(this.selectedTenant)
          })
          if (response.data && response.data.result === true) {
            this.$bvToast.toast(this.$t('views.vouchers.errors.duplicatecode'), {
              title: this.$t('common.error'),
              variant: 'danger',
              solid: true
            })
            return
          }
        } catch (e) {
          // If check fails, proceed with creation
        }
      }

      const created = await this.$store.dispatch(`${this.eParent.key}/createEntity`, entityData)
      const createdId = created && created.value && created.value.id
      if (createdId) {
        this.$router.push({ name: 'Vouchers.Detail', params: { voucherid: createdId } })
      } else {
        this.$router.push({ name: 'Vouchers' })
      }
    }
  },
  created () {
    this.$store.dispatch(`${this.eParent.key}/getDefinition`)
    this.$store.dispatch('tenants/getAll')
  }
}
</script>

<style lang="scss"></style>
